import _ from "underscore";
import { alert, hideLoader, showLoader } from "../plugins";
import { createAsyncAction } from "../utils/ajex";
import Services from "../api/services";
import * as aj from "../aj/index";
import M from "../strings";
import * as _query from "../framework/query";
import { PRIORITY_LOAD_ITEMS, UPDATE_PRIORITIES, CLEAR_PRIORITIES, PRIORITY_REORDER_ITEMS } from "../actions/types";
import * as responses from "../api/responses";
import { polish } from "../utils/lang";
import { PriorityStore } from "../stores/priority";

export const loadItems = createAsyncAction(PRIORITY_LOAD_ITEMS, data =>{
    aj.dispatch({
        type: UPDATE_PRIORITIES
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get("priorities", polish({entity: data.entity, level: data.level, parent: data.parent}))
            .then((response) => {
                loadItems.complete({
                    items: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadItems.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const reorderItems = aj.createAction(PRIORITY_REORDER_ITEMS, data => {
    const items = data.items;
    aj.dispatch({
        type: PRIORITY_REORDER_ITEMS,
        items: items,
    })
})

export const updatePriorities = createAsyncAction(UPDATE_PRIORITIES, data =>{
    aj.dispatch({
        type: UPDATE_PRIORITIES
    })

    return new Promise((resolve, reject) => {
        const items = PriorityStore.state?.items ?? [],
            orderedValues = _.pluck(items, "id");

        if (orderedValues.length > 0) {
            showLoader();
                Services.postJson("priorities", {entity: data.entity, level: data.level, orderedValues})
                    .then((response) => {
                        updatePriorities.complete({
                            priorities: response.value,
                        });
                        resolve();
                    })
                    .catch(e => {
                        alert(M("ooops"), responses.msg(e), "error");
                        updatePriorities.fail();
                        reject();
                    })
                    .finally(hideLoader)
        } else {
            updatePriorities.complete({
                priorities: [],
            });
            resolve();
        }
    })
});

export const clearPriorities = () => aj.dispatch({type: CLEAR_PRIORITIES})